import { useContext } from "react";
import { LoaderContext } from "../../contexts/loaderContext";
import { BOT_URL } from "../../apis/apis";

const useLoader = () => {
  const { toast, points, loading,showRedirect, setLoader,setProgessCount,count,setRedirectToTool,isRedirectTool, isFromBot , setIsFromBots, setToast, setShowRedirects} = useContext(LoaderContext);
  const setLoading = (status) =>  setLoader(status);
  const setToasts = (status, redirect = true) =>  {
    setToast(status);
    if((Boolean(redirect) === true && status?.show === true)){
      setTimeout(() => {
      window.location.href = BOT_URL;
    },2000)
    }
  };
  const setIsFromBot = (status) =>  setIsFromBots(status);
  const setCount = (count) => setProgessCount(count);
  const setRedirectTool = (redirect) =>  setRedirectToTool(redirect)
  const setShowRedirect = (redirect) =>  {
    setShowRedirects(redirect);
    if(redirect == "redirect"){
      window.location.href = BOT_URL
    }
  };
  return { toast, loading, showRedirect, points,count,isRedirectTool, isFromBot, setShowRedirect, setLoading,setCount,setRedirectTool ,setIsFromBot,setToasts};
};

export default useLoader;
